module.exports = __webpack_public_path__ + "img/thirdService.f3dabe3c.svg";